"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../../utils/index.js";
import { cleanTableProps } from "../cleanTableProps.js";
import { useTableContext } from "../Table/index.js";
import { useTableBodyContext } from "../TBody/index.js";
import { useTableRowContext } from "../Tr/index.js";
import { useTableRowDrawerContext } from "../TrDrawer/index.js";
import { useTableRowDrawerContentContext } from "../TrDrawerContent/index.js";
import { tdVariants } from "./Td.variants.js";
const Td = /*#__PURE__*/ forwardRef(({ children, className, contentClassName, placeholder = false, ...props }, ref)=>{
    const { bordered: tableBordered, firstColumnSticky, striped: tableStriped, cellLineClamp: tableCellLineClamp, cellMaxWidth: tableCellMaxWidth, cellSize: tableCellSize, cellTextWrap: tableCellTextWrap, cellWordBreak: tableCellWordBreak, maxColumns } = useTableContext();
    const { striped: tableBodyStriped, cellLineClamp: tableBodyCellLineClamp, cellMaxWidth: tableBodyCellMaxWidth, cellSize: tableBodyCellSize, cellTextWrap: tableBodyCellTextWrap, cellWordBreak: tableBodyCellWordBreak } = useTableBodyContext();
    const { striped: tableRowStriped, cellLineClamp: tableRowCellLineClamp, cellMaxWidth: tableRowCellMaxWidth, cellSize: tableRowCellSize, cellTextWrap: tableRowCellTextWrap, cellWordBreak: tableRowCellWordBreak, isGroupHeader } = useTableRowContext();
    const { isDrawer, isOpen } = useTableRowDrawerContext();
    const { isDrawerContent } = useTableRowDrawerContentContext();
    const { lineClamp: cellLineClamp, maxWidth: cellMaxWidth, size: cellSize, textWrap: cellTextWrap, wordBreak: cellWordBreak } = props;
    const lineClamp = cellLineClamp ?? tableRowCellLineClamp ?? tableBodyCellLineClamp ?? tableCellLineClamp;
    const maxWidth = cellMaxWidth ?? tableRowCellMaxWidth ?? tableBodyCellMaxWidth ?? tableCellMaxWidth;
    const size = cellSize ?? tableRowCellSize ?? tableBodyCellSize ?? tableCellSize;
    const textWrap = cellTextWrap ?? tableRowCellTextWrap ?? tableBodyCellTextWrap ?? tableCellTextWrap;
    const wordBreak = cellWordBreak ?? tableRowCellWordBreak ?? tableBodyCellWordBreak ?? tableCellWordBreak;
    const rowStriped = tableRowStriped ?? tableBodyStriped ?? tableStriped;
    const styles = tdVariants({
        ...props,
        size,
        firstColumnSticky,
        rowStriped,
        tableBordered,
        textWrap,
        lineClamp,
        maxWidth,
        wordBreak,
        isDrawer,
        isOpen,
        isGroupHeader
    });
    const cleanedProps = cleanTableProps(props);
    let colSpan;
    if (!isDrawerContent || isGroupHeader || placeholder) {
        if (!isDrawerContent && isGroupHeader && !placeholder) colSpan = maxColumns;
    } else colSpan = maxColumns - 1;
    return /*#__PURE__*/ jsx("td", {
        className: cn(styles.base(), className),
        colSpan: colSpan,
        ...cleanedProps,
        ref: ref,
        children: isDrawerContent ? children : /*#__PURE__*/ jsx("div", {
            className: cn(styles.content(), contentClassName),
            children: children
        })
    });
});
export { Td };
